module.exports = "<svg viewBox=\"0 0 18 26\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Group\"><path d=\"M9,0.5 C4.1625,0.5 0.25,4.4125 0.25,9.25 C0.25,15.8125 9,25.5 9,25.5 C9,25.5 17.75,15.8125 17.75,9.25 C17.75,4.4125 13.8375,0.5 9,0.5 Z M9,12.375 C7.275,12.375 5.875,10.975 5.875,9.25 C5.875,7.525 7.275,6.125 9,6.125 C10.725,6.125 12.125,7.525 12.125,9.25 C12.125,10.975 10.725,12.375 9,12.375 Z\" id=\"Shape\"></path></g></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Location.svg
// module id = 518
// module chunks = 1